up.compiler('.loading-indicator', (element) => {
  const $element = $(element)

  let $body = $('body')
  let timeout = undefined
  let transitionDelay = 300
  let slow = false

  function move() {
    let step = 0
    let width = 33

    function moveNext() {
      step++
      width = width + (width < 90 ? 1 : -1)
      moveTo(width)
      timeout = setTimeout(moveNext, transitionDelay + step * 30)
    }
    moveNext()
  }

  function moveTo(width) {
    $element.css('width', `${width}vw`)
  }

  function finish() {
    clearTimeout(timeout)
    moveTo(100)
  }

  function show() {
    $element.addClass('-visible')
    $element.css('transition', `width ${transitionDelay}ms ease-out`)
    $body.addClass('-loading-indicator')
  }

  function hide() {
    $element.css('transition', `width 0 ease-out`)
    $element.removeClass('-visible')
    $body.removeClass('-loading-indicator')
    moveTo(0)
  }

  function onSlow() {
    if (slow) return

    slow = true
    show()
    move()
  }

  function onRecover() {
    slow = false

    finish()
    setTimeout(hide, transitionDelay)
  }

  return [
    up.on('up:network:late', onSlow),
    up.on('up:network:recover', onRecover),
  ]
})
